var module = angular.module('octopusApp.projects');

module.run(function(pluginRegistry, actionExecutionLocations) {
    pluginRegistry.registerDeploymentAction("Octopus.DockerStop", function(octopusRepository, octopusFeatures) {
        return {
            executionLocation: actionExecutionLocations.alwaysOnTarget,
            canHaveChildren: function(){return true;},
            canBeChild: true,
            canChooseRoles: true,
            canShow: function() { return octopusFeatures.isEnabled('IsDockerEnabled'); },
            hasPackages: function(action) { return false; },
            summaryTemplateUrl: "areas/projects/actions/docker_stop/Octopus.DockerStop_summary.html",
            editTemplateUrl: "areas/projects/actions/docker_stop/Octopus.DockerStop_edit.html",
            preLink: function($scope) {

                octopusRepository.DeploymentProcesses.get($scope.project.DeploymentProcessId).then(function(deployment) {
                    $scope.actions = _.flatten(deployment.Steps.map(function(step, stepIndex){
                       return step.Actions.map(function CalculateNumberedName(action, actionIndex) {
                           var number = stepIndex + 1;
                           if (step.Actions.length > 1) {
                               number = number +"."+ (actionIndex + 1);
                           }
                           action.NumberedName = number +'. '+ action.Name;
                           return action;
                       });
                   }))
                        .filter(function(action) { return action.ActionType === 'Octopus.DockerNetwork' || action.ActionType === 'Octopus.DockerRun'; })
                        .map(function(action) {
                            return {Name: action.NumberedName, Id: action.Id};
                        });
                });

                $scope.vm = {
                    selectedActions: ($scope.action.Properties["Octopus.Action.Docker.RemoveSteps"] || "").split(",").filter(function(step) {return !!step;})
                };

                $scope.actionsChanged = function() {
                    $scope.action.Properties["Octopus.Action.Docker.RemoveSteps"] = $scope.vm.selectedActions.join(',');
                };

                if (!$scope.action.Properties["Octopus.Action.Docker.Remove"]) {
                    $scope.action.Properties["Octopus.Action.Docker.Remove"] = "True";
                }

                $scope.filterChanged = function(){
                    $scope.action.Properties["Octopus.Action.Docker.RemoveByEnvironment"] = ($scope.filterBy.environment === "True") ? "True" : "False";
                    $scope.action.Properties["Octopus.Action.Docker.RemoveByRelease"] = ($scope.filterBy.release === "True") ? "True" : "False";
                    $scope.action.Properties["Octopus.Action.Docker.RemoveByTenant"] = ($scope.filterBy.tenant === "True") ? "True" : "False";
                };

                $scope.filterBy = {
                    environment: $scope.action.Properties["Octopus.Action.Docker.RemoveByEnvironment"],
                    release: $scope.action.Properties["Octopus.Action.Docker.RemoveByRelease"],
                    tenant: $scope.action.Properties["Octopus.Action.Docker.RemoveByTenant"]
                };

            },
            summaryLink: function($scope, element) {

            }
        };
    });
});


//////////////////
// WEBPACK FOOTER
// ./app/areas/projects/actions/docker_stop/Octopus.DockerStop.js
// module id = 7705969795150367
// module chunks = 1